export default {"src":"/_next/static/media/family-dog.b588591b.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};